<template>
  <div >
    <topnav />
    <div class="tabs">
      <div class="tab" @click="toggleTab('activityclass')" :class="currentTab== 'activityclass'? 'active' : '' "><a>大讲堂</a></div>
      <div class="tab" @click="toggleTab('activitystudy')" :class="currentTab== 'activitystudy'? 'active' : '' "><a>学术讲座</a></div>
      <div class="tab" @click="toggleTab('activitypublic')" :class="currentTab== 'activitypublic'?'active' : '' "><a>公共活动</a></div>
    </div>
    <prince :is="currentTab" keep-alive></prince>
  </div>
</template>

<script>
  import topnav from '../components/topnav';
  import activitystudy from './activitystudy';
  import activityclass from './activityclass';
  import activitypublic from './activitypublic';
  export default {
    name: 'app',
    data () {
      return {
        currentTab: 'activityclass' // currentTab 用于标识当前触发的子组件
      };
    },
    components: { // 声明子组件
      topnav,
      activitystudy,
      activityclass,
      activitypublic
    },

    beforeRouteEnter(to,from,next){
      next(e=>{
        e.currentTab=e.$route.query.newsType||"activityclass";
       })
    },
    mounted(){
      $(".footmenu li").eq(0).addClass('router-link-exact-active').addClass('router-link-active')
    },
    methods: {
      toggleTab: function(tab) {
        if(tab === "activityclass"){
          this.$router.push({ path: 'activity', query: {newsType:'activityclass'}})
        }
        if(tab === "activitystudy"){
          this.$router.push({ path: 'activity', query: {newsType:'activitystudy'}})
        }
        if(tab === "activitypublic"){
          this.$router.push({ path: 'activity', query: {newsType:'activitypublic'}})
        }
        this.currentTab = tab; // tab 为当前触发标签页的组件名
      }
    }
  }
</script>
<style lang="scss" scoped="">
.tabs{
  display: flex;
  height: 1.55rem;
  background-color: rgba(255, 255, 255, 1);
   padding: .35rem .75rem;
  margin-bottom: .5rem;
}
  .tab{
    // float: left;
    // width: 8.5rem;
    flex: 1;
    height: 1.4rem;
    border: 0.05rem solid rgba(196, 77, 65, 1);
    text-align: center;
  }
  .tab.active{
    background-color: rgba(196, 77, 65, 1);
  }
 .tab:nth-child(1){
  border-top-left-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
}
.tab:last-child{
  border-top-right-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}
.tab.active a{
  color: rgba(255, 255, 255, 1);
}
  .tab a{
    height:1.4rem;
    line-height: 1.4rem;
    font-size: 0.7rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    color: rgba(196, 77, 65, 1);


  }
</style>



// WEBPACK FOOTER //
// src/view/activity.vue